import React, { useState } from 'react';
import {
  Row,
  Col,
  Divider,
  Input,
  Typography,
  Button,
  Table,
  Space,
  Skeleton,
  Result
} from 'antd';
import {
  SearchOutlined,
} from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { formatPhone } from '../../utils/customFunctions';
import DeletePopupButton from './components/DeletePopupButton';
import CreateButton from '../../components/CreateButton';


const columns = [
  {
    title: 'ชื่อ',
    dataIndex: 'fname',
    key: 'fname',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/employees/edit/${record._id}`}
        style={{
          width: "100%",
          textAlign: 'left',
          background: 'none'
        }}>
        {text}
      </Button>
  },
  {
    title: 'นามสกุล',
    dataIndex: 'lname',
    key: 'lname',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/employees/edit/${record._id}`}
        style={{
          width: "100%",
          textAlign: 'left',
          background: 'none'
        }}>
        {text}
      </Button>
  },
  {
    title: 'เบอร์โทร',
    dataIndex: 'phone',
    key: 'phone',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/employees/edit/${record._id}`}
        style={{
          width: "100%",
          textAlign: 'left',
          background: 'none'
        }}>
        {formatPhone(text)}
      </Button>
  },
  {
    title: 'ตำแหน่ง',
    dataIndex: 'position',
    key: 'position',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/employees/edit/${record._id}`}
        style={{
          width: "100%",
          textAlign: 'left',
          background: 'none'
        }}>
        {text}
      </Button>
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <DeletePopupButton data={record} />
      </Space>
    ),
  }
]

function List() {
  const [filterData, setFilterData] = useState(null);
  const { isError, isLoading, data, error } = useQuery({
    queryKey: ['/api/employee/'],
  })


  if (isLoading) {
    return <Skeleton active />
  }

  if (isError) {
    return <Result status="error" title={error.message} />
  };

  const onSearch = e => {
    const s = e.target.value;
    const target = data.filter(f => f.fname.includes(s) || f.lname.includes(s) || f.phone.includes(s))
    setFilterData(target);
  }

  // console.log('data =>', data);
  // console.log('search =>', search);
  return (
    <div style={{
      background: '#fff',
    }}>

      <Row justify='space-between' >
        <Col xs={24} md={12} >
          <Typography.Title level={3}>
            รายการพนักงาน
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Row justify="end">
            <Col>
              <CreateButton linkTo='/admin/employees/create' />
            </Col>
          </Row>
        </Col>
        <Divider />
        <Col xs={24} >
          <Row justify='space-between' gutter={[0, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Input placeholder="ค้นหา" prefix={<SearchOutlined />} onChange={onSearch} />
            </Col>
            <Col xs={24}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={filterData || data} />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default List